export default __webpack_public_path__ + "static/media/carrie-modal.109cc039.jpg";